import { PortableText } from '@portabletext/react';
import classNames from 'classnames';

import { ImagePTComponentInterface } from '@/src/assets/interfaces/imagePTinterface';
import { getImageUrl } from '@/src/assets/utils/getImageUrl';
import { getRel } from '@/src/assets/utils/getRel';
import { isBlank } from '@/src/assets/utils/isBlank';

import NextImage from '../../UI/nextImage/NextImage';
import { LinkPTComponent } from '../linkPTComponent/LinkPTComponent';

import styles from './ImagePTComponent.module.scss';

const captionPortableTextComponents = {
    marks: {
        link: LinkPTComponent,
    },
};

const ImagePTComponent = ({ value }: ImagePTComponentInterface) => {
    const hasSizeOption = !!value.imageSize || !!value.customImageSize;
    const isSVG = !!value?.asset?._ref.endsWith('svg');
    let rel;
    let isBlankValue;
    let maxImageSize = isSVG ? '400' : '1184';

    if (!value.asset) {
        return '';
    }

    if (value?.link?.url) {
        rel = getRel(value?.link?.relOverride, value?.link?.url);
        isBlankValue = isBlank(value?.link?.url, value?.link?.isBlank) ? '_blank' : undefined;
    }

    if (value.imageSize && value.imageSize !== 'default') {
        maxImageSize = value.imageSize;
    }

    if (value.customImageSize) {
        maxImageSize = value.customImageSize.toString();
    }

    const inlineStyles = hasSizeOption
        ? {
              width: '100%',
              maxWidth: `${maxImageSize}px`,
          }
        : undefined;

    return value?.caption ? (
        <figure
            style={inlineStyles}
            className={classNames(styles.postContentFigure, { [styles.svgImage]: isSVG })}>
            {value.link?.url ? (
                <a
                    href={value.link.url}
                    rel={rel}
                    target={isBlankValue}
                    className={styles.postContentImageLink}>
                    <NextImage
                        className={styles.postContentImage}
                        alt={value.alt || ''}
                        src={getImageUrl(value)}
                        fill={true}
                        loading={'lazy'}
                        style={inlineStyles}
                        sizes={`(max-width: 1280px) 100vw, ${maxImageSize}px`}
                    />
                </a>
            ) : (
                <NextImage
                    className={classNames(styles.postContentImage, { [styles.svgImage]: isSVG })}
                    alt={value.alt || ''}
                    src={getImageUrl(value)}
                    fill={true}
                    loading={'lazy'}
                    sizes={`(max-width: 1280px) 100vw, ${maxImageSize}px`}
                    style={inlineStyles}
                />
            )}
            <figcaption className={styles.postContentFigcaption}>
                <PortableText value={value.caption} components={captionPortableTextComponents} />
            </figcaption>
        </figure>
    ) : (
        <>
            {value?.link?.url ? (
                <a
                    href={value.link.url}
                    rel={rel}
                    target={isBlankValue}
                    className={styles.postContentImageLink}>
                    <NextImage
                        className={classNames(styles.postContentImage, {
                            [styles.svgImage]: isSVG,
                        })}
                        alt={value.alt || ''}
                        src={getImageUrl(value)}
                        fill={true}
                        loading={'lazy'}
                        sizes={`(max-width: 1280px) 100vw, ${maxImageSize}px`}
                        style={inlineStyles}
                    />
                </a>
            ) : (
                <NextImage
                    className={classNames(styles.postContentImage, { [styles.svgImage]: isSVG })}
                    alt={value?.alt || ''}
                    src={getImageUrl(value)}
                    fill={true}
                    loading={'lazy'}
                    sizes={`(max-width: 1280px) 100vw, ${maxImageSize}px`}
                    style={inlineStyles}
                />
            )}
        </>
    );
};

export { ImagePTComponent };
